import { AfterContentInit, Component, ElementRef, HostListener, OnInit, QueryList,  ViewChild, ViewChildren } from '@angular/core';
import { PageService } from 'src/app/services/shared/page.service';
import { Page } from 'src/app/models/page.model';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonService, MessagesService } from '../services/service.index';
import { MicroapplicationService } from 'src/app/services/microapplications/_services/microapplication.service';
import { ConfigService } from '../services/config.service';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})

export class PagesComponent implements OnInit, AfterContentInit {



isMouseDown = false;
  public sessionData = JSON.parse(sessionStorage.getItem('sessionData') || '{}');
  public favoriteListArr: any[] = [];
  public favoriteSelected: any;
  public idFormCurrent: any;
  public showOptionsFav: boolean = false;
  public codUser: string;
  public dataAmbiente: any;
  public dateUpdateBoards: string = "";
  public ruta: string = "";
  public btnDisabled: boolean = true;
  public subscriber: Subscription = new Subscription;
  public showProcess: boolean = false;
  public listProcess: any = [];
  public initialListProcess: any[] = [];
  
  private listForm = JSON.parse((sessionStorage.getItem('List_form') || '{}'));
  public admin = {
    cod_prog: 'admin-process',
    nom_prog: 'Administrador de procesos',
    idForm: 'admin-process',
    nom_fisi: '/formio/admin-process',
    view: true
  };

  @ViewChild("favoriteIcon") favoriteIcon: any;
  @ViewChild("favoriteBody") favoriteBody: any;
  @ViewChild("oneProcess") oneProcess: any;
  @ViewChildren("listProcessDom") listProcessDom!: QueryList<any[]>;
    private messageListener!: (event: MessageEvent) => void;
  licenciamessage: any;
  conpany: any;
  user_code: any;

  iframeChat:any;
  constructor(
    private MicroapplicationService:MicroapplicationService,
    private _pageService: PageService,
    private messagesService: MessagesService,
    private _commonServices: CommonService,
    private configService: ConfigService,
    private router: Router) {
    this.codUser = '';
  }

  ngOnInit(): void {
    this.conpany = this.sessionData.selectedCompany.code;
    this.user_code = this.sessionData.accountCode;
    
    let dateIni = new Date();
    this.dateUpdateBoards = `${dateIni.getDate()}/${dateIni.getMonth()+1}/${dateIni.getFullYear()} ${dateIni.getHours()}:${dateIni.getMinutes()}`
   this.ValidarLicencia();
   

    
    this.ruta = this.router.url;
    this.adjustScale();
    this.iframeChat= this.configService.config.urlchatIAfinance;

  }

  adjustScale() {
    
    const width = window.innerWidth;
    let scale = 1;
  
    if (width >= 1920) {
      scale = 1.1;
    } else if (width >= 1386 && width < 1920) {
      scale = 1.0;
    } else {
      scale = 0.9;
    }
  
    const body = document.body;
  
    body.style.transform = `scale(${scale})`;
    body.style.transformOrigin = 'top left';
    body.style.width = `${100 / scale}%`;

    document.documentElement.style.height = '100%';
body.style.height = `${100 / scale}%`;
  }

  

  ValidarLicencia(): void {

    this.MicroapplicationService.ValidarLicencia(this.user_code,this.conpany).subscribe(resp => {
      if (resp.isSuccessful) {
        this.licenciamessage=resp.errorMessage;
        this._commonServices.setItemsessionStorage('licen', "V");
    }
      else {
        this._commonServices.setItemsessionStorage('licen', "N");
        this.licenciamessage=resp.errorMessage;
      }
    });

  }

  // ngAfterContentInit(): void {
  //   // this.getListProcess();
  //   window.addEventListener("message", (event) => {      
  //     if (event.data.type == "startProcessAdpro") {
  //       this.showProcess = true;
  //       this.idFormCurrent = event.data.data.codForm;
  //       // this.getListProcess();        
  //     } else if (event.data.type == "endProcessAdpro") this.getListProcess();
  //   });
  //   setTimeout(() => {
  //     // this.adproService.queryTabs.emit();
  //   }, 1000);
  // }

    ngAfterContentInit(): void {
    this.messageListener = (event: MessageEvent) => {

      if (event.origin !== window.location.origin) {
        console.warn(`Mensaje rechazado de origen no permitido: ${event.origin}`);
        return;
      }

      if (!event.data?.type) return;

      if (event.data.type === "startProcessAdpro") {
        this.showProcess = true;
        this.idFormCurrent = event.data.data?.codForm;
      } else if (event.data.type === "endProcessAdpro") {
 
      }
    };

    window.addEventListener("message", this.messageListener);
  }

  ngOnDestroy(): void {
    window.removeEventListener("message", this.messageListener);
  }

  generarPage(forma: any, admin=false) {
    const page: Page = {
      codProg: forma.cod_prog,
      name: forma.nom_prog,
      idForm: forma.idForm,
      id: 0,
      url: forma.nom_fisi.toLowerCase(),
      cambiarUrl: true,
      view: forma.hasOwnProperty('view') ? forma.view : false,
      lisnk:null
    }
    !admin?page.url = page.url+'&cod_prog='+ page.codProg: null
    this._pageService.generarPage(page);
    // this.favoritesChange();
  }


  deleteFavorite(event: any, forma: any): void {
    this.favoriteSelected = forma;
    event.preventDefault();
    this.showOptionsFav = false;
  }

  addListfavorite(data: any) {
    this.favoriteListArr.push(data)
  }

  favoritesChange = () => {
    setTimeout(() => {
      if (this.favoriteBody.nativeElement.classList.contains("sp-offcanvas-panel--on")) {
        this.favoriteIcon.nativeElement.classList.add("d-none")
      } else {
        this.favoriteIcon.nativeElement.classList.remove("d-none")
      }

      document.getElementsByClassName('sp-offcanvas-panel-overlay')[0].addEventListener('click', (event) => {
        if (!this.favoriteBody.nativeElement.classList.contains("sp-offcanvas-panel--on")) {
          this.favoriteIcon.nativeElement.classList.remove("d-none")
        }
        document.querySelectorAll('.sp-offcanvas-panel-overlay').forEach(e => e.remove());


      });
    }, 100);

  }



  calcListProgress() {
    setTimeout(() => {
      if (this.listProcess?.length == 1) {
        this.calcProgress(this.oneProcess.nativeElement.querySelector('.circular-progress'), this.listProcess[0].porProc, this.listProcess[0].tieErrores);
      } else if (this.listProcess?.length > 1) {
        this.listProcessDom.toArray().forEach((e: any, i: any) => {
          this.calcProgress(e.nativeElement.querySelector('.circular-progress'), this.listProcess[i].porProc, this.listProcess[i].tieErrores);
        });
      };
    }, 500);
  }

  calcProgress(circular: any, status: any, errores: any) {
    let progressStar = 0;
    let progressEnd = status + 1;
    let speed = 10;
    let progresss = setInterval(() => {
      progressStar++;
      if (progressEnd <= 60) {
        (circular as any).style.background = `conic-gradient(#F8BD1F ${progressStar * 3.6}deg, #E6EAF1 0deg)`;
      } else if (progressEnd <= 99) {
        (circular as any).style.background = `conic-gradient(#306500 ${progressStar * 3.6}deg, #E6EAF1 0deg)`;
      } else if (errores) {
        (circular as any).style.background = `conic-gradient(#B60000 ${progressStar * 3.6}deg, #E6EAF1 0deg)`;
      } else {
        (circular as any).style.background = `conic-gradient(#306500 ${progressStar * 3.6}deg, #E6EAF1 0deg)`;
      }
      if (progressStar == progressEnd || progressStar == 101) {
        clearInterval(progresss);
      }
    }, speed);
  };

  saveFormCurrent(e: any) {
    if (e) {      
      if(e.codProg == "admin-process") this.idFormCurrent = "admin-process"; 
      else this.idFormCurrent = e.url.split("cod_form=")[1].split("&")[0];
      this.calcProcess(this.idFormCurrent);
    };
  };
  
  hiddenProcess(idForm?: any) {
    if(idForm){
      this.listProcess = this.listProcess.filter((e: any) => {
        return e.codForm.toLocaleLowerCase() !== idForm.toLocaleLowerCase();
      });
    } else {
      this.showProcess = false;
      this.listProcess = [];
    };
  };

  calcProcess(idForm: any) {
    if(idForm == "admin-process") this.listProcess = [];
    else this.listProcess = this.initialListProcess.filter(e => {
      return e.codForm.toLocaleLowerCase() !== idForm.toLocaleLowerCase();
    });    
    this.calcListProgress();
  };

  parseInt(num: any) {
    return parseInt(num);
  };

  reloadBoards() {  
    this.btnDisabled = true;
    // this.boardService.reloadBoards.emit();
  };



}
